import React from 'react';

import { Image, Text } from '@change/ds-core-ui';

import { translationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import StepCtaImageUrl from '#src/app/pages/local/details/shared/assets/sap.png';
import { SapCtaBanner } from '#src/app/shared/components/SapCtaBanner';

export const StepCTA: React.FC = () => {
	const { translate } = useI18n();
	const track = useTracking();

	const steps = [
		{
			step: 1,
			heading: translate('corgi.local.steps_cta.step_1.heading'),
			subheading: translate('corgi.local.steps_cta.step_1.subheading'),
		},
		{
			step: 2,
			heading: translate('corgi.local.steps_cta.step_2.heading'),
			subheading: translate('corgi.local.steps_cta.step_2.subheading'),
		},
		{
			step: 3,
			heading: translate('corgi.local.steps_cta.step_3.heading'),
			subheading: translate('corgi.local.steps_cta.step_3.subheading'),
		},
	];

	return (
		<div className="flex flex-col gap-4">
			<div className="bg-background-raised flex flex-col-reverse justify-between gap-6 rounded-xl p-10 md:flex-row">
				<div className="text-typography-strong flex flex-col gap-6">
					{steps.map(({ step, heading, subheading }) => (
						<div className="flex flex-col gap-2" key={step}>
							<Text as="h3" variant="heading" size="small">
								{`${step}. ${heading}`}
							</Text>
							<Text>{subheading}</Text>
						</div>
					))}
				</div>

				<Image
					className="h-[234px] w-[257px] self-center rounded-xl object-cover"
					src={StepCtaImageUrl}
					alt={translate('corgi.local.steps_cta.image_alt')}
				/>
			</div>

			<SapCtaBanner
				headingKey={translationKey('corgi.local.steps_cta.heading')}
				buttonKey={translationKey('corgi.local.steps_cta.button')}
				sourceLocation="local_cta"
				className="flex flex-col p-10 max-lg:gap-10 md:flex-row md:items-center md:justify-between"
				buttonClassName="max-md:mx-auto max-md:w-full"
				buttonQa="footer-sap-button"
				onButtonClick={() => {
					void track('local_sap_click_bottom');
				}}
			/>
		</div>
	);
};
